<script lang="ts">
    import {getPageContext} from 'shared/layouts';
    import {AnalyticsEmbed} from 'src/features/erp-sutor/features/analytics';
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from 'src/features/record/kp-document-detail-page/types';

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const projectRecord = pageContext.staticData.model.record;
</script>

<AnalyticsEmbed type="dashboard" id="3" params={{record: projectRecord.id, params: [{name: 'nearest_project', valueType: 'origin'}]}}/>
